import React, { useState, useEffect, useContext } from "react";
import OrderField from "../shared/order_field";
import { useFormContext, Controller } from "react-hook-form";
import Select from "react-select";
import { OrderContext } from "../../../contexts/order_context";

const routeToHash = (route) => {
  return {
    value: route.id,
    label: route.name,
    flight_number: route.flight_number,
  };
};

const OrderTransport = ({ routes, isError }) => {
  const { townId } = useContext(OrderContext);
  const [airport, setAirport] = useState(undefined);
  const [convertedRoutes, setConvertedRoutes] = useState({
    startRoutes: [],
    endRoutes: [],
  });

  // Sets the airport according to the chosen town, selects the same airport for the end route
  const routeByTown = (townRoutes) => {
    if (typeof townRoutes == "undefined") return null;

    const routesForTown = townRoutes.filter((route) => route.town_id == townId);

    if (routesForTown.length === 0) return undefined;

    const route = airport
      ? routesForTown.find((route) => route.airport === airport)
      : routesForTown[0];

    if (route) {
      if (!airport) setAirport(route.airport);
      return routeToHash(route);
    } else {
      return undefined;
    }
  };

  const routeByAirport = (startRoutes, endRoutes, type) => {
    if (typeof startRoutes == "undefined" || typeof endRoutes == "undefined")
      return null;

    const startAirports = startRoutes.map((route) => route.airport);
    const endAirports = endRoutes.map((route) => route.airport);
    const intersectAirports = startAirports.filter((airport) =>
      endAirports.includes(airport)
    );

    if (intersectAirports.length === 0) return undefined;

    const route =
      type == "starts"
        ? startRoutes.find((route) => route.airport === intersectAirports[0])
        : endRoutes.find((route) => route.airport === intersectAirports[0]);

    if (!route) return undefined;

    return routeToHash(route);
  };

  const selectedTownRoutes = {
    start:
      routeByTown(routes?.route_starts) ||
      routeByAirport(routes?.route_starts, routes?.route_ends, "starts"),
    end:
      routeByTown(routes?.route_ends) ||
      routeByAirport(routes?.route_starts, routes?.route_ends, "ends"),
  };

  const convertRoutesToOptions = () => {
    const startRoutes = mapRoutes(routes?.route_starts);
    const endRoutes = mapRoutes(routes?.route_ends);
    return { startRoutes, endRoutes };
  };

  const mapRoutes = (rts) => rts?.map((route) => routeToHash(route));

  const {
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext({
    defaultValues: {
      route_start: selectedTownRoutes.start,
      route_end: selectedTownRoutes.end,
    },
  });

  useEffect(() => {
    setConvertedRoutes(convertRoutesToOptions());
    if (getValues("route_start") == undefined) {
      setValue("route_start", selectedTownRoutes.start);
    }
    if (getValues("route_end") == undefined) {
      setValue("route_end", selectedTownRoutes.end);
    }
  }, [routes]);

  useEffect(() => {
    if (
      typeof convertedRoutes.startRoutes === "undefined" ||
      typeof convertedRoutes.endRoutes === "undefined"
    )
      return;
    const term2 = getValues("term2");
    const routeStart =
      selectedTownRoutes.start || convertedRoutes.startRoutes[0];
    const routeEnd = selectedTownRoutes.end || convertedRoutes.endRoutes[0];
    const routeEndKey = term2 ? "route_end2" : "route_end";
    if (getValues("route_start") != routeStart)
      setValue("route_start", routeStart);
    if (getValues(routeEndKey) != routeEnd) setValue(routeEndKey, routeEnd);
  }, [convertedRoutes]);

  return (
    <OrderField title={I18n.t("js.order.fields.transport")}>
      {isError ? (
        <div className="alert alert-danger">
          {I18n.t("js.order.routes.not_found")}
        </div>
      ) : (
        <div className="row order-form__block-content">
          <div
            className="row"
            id="order_routes"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div className="form-group col-md-6 col-lg-5">
              <label>{I18n.t("js.order.route_start_id")}</label>
              <Controller
                name="route_start"
                control={control}
                render={({ field: { onChange, value } }) => {
                  return (
                    <div style={{ width: "300px" }}>
                      <Select
                        options={convertedRoutes.startRoutes}
                        onChange={onChange}
                        value={value}
                        isSearchable={false}
                        placeholder=" "
                      />
                    </div>
                  );
                }}
              />
              <div className="mt-2">
                {getValues("route_start")?.flight_number &&
                  `${I18n.t("js.order.routes.flight_number")}: ${
                    getValues("route_start").flight_number
                  }`}
              </div>
            </div>
            <div className="form-group col-md-6 col-lg-5">
              <label>{I18n.t("js.order.route_end_id")}</label>
              <Controller
                name="route_end"
                control={control}
                render={({ field: { onChange, value } }) => {
                  return (
                    <div style={{ width: "300px" }}>
                      <Select
                        options={convertedRoutes.endRoutes}
                        onChange={onChange}
                        value={value}
                        isSearchable={false}
                        placeholder=" "
                      />
                    </div>
                  );
                }}
              />
              <div className="mt-2">
                {getValues("route_end")?.flight_number &&
                  `${I18n.t("js.order.routes.flight_number")}: ${
                    getValues("route_end").flight_number
                  }`}
              </div>
            </div>
          </div>
        </div>
      )}
    </OrderField>
  );
};

export default OrderTransport;
